export class Contact {
    id: number;
    firstName: string = "";
    lastName: string = '';
    email: string = "";
    mobile: string = "";
    rol: string = "";
    category: string = "";
    subject: string = "";
    read: boolean = false;
    text: string = "";
    language: string;
}